"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
rxjs_1.Observable.race = rxjs_1.race;
//# sourceMappingURL=race.js.map